import { View } from 'react-native';
import { Modal } from '@/components/ui/therapist/Modal';
import { Button } from '@/components/ui/therapist/Button';
import { Input } from '../ui/therapist/Input';

interface SetSaveModalProps {
  isVisible: boolean;
  setIsVisible: (visible: boolean) => void;
  handleInputChange: (key: string) => (value: string) => void;
  handleModalAcceptButton: () => void;
  inputState: { [key: string]: string };
  modalTitle: string;
  handleButtonPress: () => void;
  apiKeyName: 'wordsets' | 'sentencesets' | 'textsets';
}

const inputs = {
  wordsets: [
    { key: 'name', label: 'Wörterset Name', placeholder: 'Neues Wörterset' },
    {
      key: 'appDisplayName',
      label: 'Name für Eigentraining (optional, max 16 Zeichen)',
      placeholder: 'Wörter',
    },
  ],
  sentencesets: [
    { key: 'name', label: 'Sätzeset Name', placeholder: 'Neues Sätzeset' },
    {
      key: 'appDisplayName',
      label: 'Name für Eigentraining (optional, max 16 Zeichen)',
      placeholder: 'Sätze',
    },
  ],
  textsets: [
    { key: 'name', label: 'Texteset Name', placeholder: 'Neues Texteset' },
    {
      key: 'appDisplayName',
      label: 'Name für Eigentraining (optional, max 16 Zeichen)',
      placeholder: 'Texteset',
    },
  ],
};

export const SetSaveModal = ({
  isVisible,
  setIsVisible,
  handleInputChange,
  handleModalAcceptButton,
  inputState,
  apiKeyName,
  modalTitle,
  handleButtonPress,
}: SetSaveModalProps) => {
  return (
    <Modal
      title={modalTitle}
      onClose={() => setIsVisible(false)}
      isVisible={isVisible}
      confirmActionButton={
        <Button label="Set abspeichern" onPress={handleModalAcceptButton} />
      }
      cancelActionButton={
        <Button
          look="secondary"
          label="Speichern abbrechen"
          onPress={handleButtonPress}
        />
      }
    >
      <View>
        {inputs[apiKeyName].map((input, index) => {
          return (
            <View key={input.key}>
              <Input
                label={input.label}
                onChange={handleInputChange(input.key)}
                value={inputState[input.key]}
                maxLength={index === 1 ? 16 : undefined}
                placeholder={input.placeholder}
              />
            </View>
          );
        })}
      </View>
    </Modal>
  );
};
